import React from 'react';
import Header from '../../header/Header'
import Button from '../../../elements/buttons/Button'
import Heading1 from '../../../elements/titles/Heading1'
import bgHeader from '../../../../medias/images/bg-header-about.jpg'

function HeaderAbout({ children, img }) {


    return (
        <Header
            className=" bg-cover mt-20 h-72"
            img={bgHeader}
            id="headerAbout"
        >
            <div className="flex flex-col items-center">
                <Heading1
                    theme="white"
                    size="medium"
                    classe="relative z-30 text-center"
                >
                    Parlons de moi et de mon travail
                </Heading1>
                <div className="relative z-30">
                    <Button
                        link="/contact"
                        size="big"
                        classe="mt-8 rounded-full"
                    >
                        Traduire un projet
                    </Button>
                </div>
            </div>
        </Header>
    );
}

export default HeaderAbout;